/**
 * Created by Jerker Nord on 2020-06-17.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../MonkeysGoldGameConfig";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MonkeysGoldGameModuleConfig} from "../MonkeysGoldGameModuleConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../MonkeysGoldSoundConfig";

export class MonkeysGoldAvalancheSymbolAttentionController extends BaseView {

    private _spineSymbols:PIXI.spine.Spine[][];
    private _winPositions:boolean[][];
    private _spineAttentionSymbols:PIXI.spine.Spine[][];
    private _soundPlayedOnReel:boolean[] = [false, false, false, false, false, false];

    constructor() {
        super();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.WIN_PRESENTATIONS_2.name).addChild(this);
    }

    protected initAnimations():void {
        this._spineSymbols = [];
        for(let i:number = 0; i < 6; i++) {
            const reel:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 6; j++) {
                const symbol:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("spineSymsWin"));
                symbol.position.x = Helper.getSymbolPositions(i, j)[0];
                symbol.position.y = Helper.getSymbolPositions(i, j)[1];
                symbol.visible = false;
                this.addChild(symbol);
                reel.push(symbol);
            }
            this._spineSymbols.push(reel);
        }

        this._spineAttentionSymbols = [];
        for(let i:number = 0; i < 6; i++) {
            const reel:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 6; j++) {
                const symbol:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("spineWinBlastYellow"));
                symbol.position.x = Helper.getSymbolPositions(i, j)[0];
                symbol.position.y = Helper.getSymbolPositions(i, j)[1];
                symbol.visible = false;
                this.addChild(symbol);
                reel.push(symbol);
            }
            this._spineAttentionSymbols.push(reel);
        }

        this._winPositions = [];
        for(let i:number = 0; i < 6; i++) {
            const reel:boolean[] = [];
            for(let j:number = 0; j < 6; j++) {
                reel.push(false);
            }
            this._winPositions.push(reel);
        }
    }

    public resetPlayedSounds():void {
        for(let i:number = 0; i < this._soundPlayedOnReel.length; i++) {
            this._soundPlayedOnReel[i] = false;
        }
    }

    public getLandingAnimationTL(landingPositions:PIXI.Point[], reelId:number):TimelineLite {
        const mainLandingTL:TimelineLite = new TimelineLite();

        const subTLs:TimelineLite[] = [];
        let playSound:boolean = true;
        for(let i:number = 0; i < landingPositions.length; i++) {
            let reel:number = landingPositions[i].x;
            let row:number = landingPositions[i].y;
            let subTL:TimelineLite = new TimelineLite();
            subTL.add(() => this._spineSymbols[reel][row].skeleton.setSlotsToSetupPose());
            subTL.add(() => this._spineSymbols[reel][row].updateTransform());
            subTL.add(() => this._spineSymbols[reel][row].visible = true);
            subTL.add([
                new SpineTween(this._spineSymbols[reel][row], 0, "landing_animation", 0),
                () => {
                    if(playSound == true) {
                        playSound = false;
                        (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.WIN_SYMBOLS_LANDING)});
                    }
                }
            ]);
            subTL.add(() => this._spineSymbols[reel][row].visible = false);
            subTLs.push(subTL);
        }
        mainLandingTL.add(subTLs);
        return mainLandingTL;
    }

    public playSymbolAttention(reel:number, positions:boolean[]):void {
        const hightlightTL:TimelineLite = new TimelineLite();
        let tempSymName:string;
        for(let i:number = 0; i < positions.length; i++) {
            if(positions[i] == true) {
                this._spineAttentionSymbols[reel][i].position.x = Helper.getSymbolPositions(reel, i)[0];
                this._spineAttentionSymbols[reel][i].position.y = Helper.getSymbolPositions(reel, i)[1];
                tempSymName = Reels.getSymbol(reel, i)!.symName;
                if(tempSymName.indexOf("hidden") == -1) {
                    if(tempSymName.indexOf("x2") > -1) {
                        this._spineAttentionSymbols[reel][i].scale.set(240 / 360, 240 / 360);
                        this._spineAttentionSymbols[reel][i].position.x -= 60;
                        this._spineAttentionSymbols[reel][i].position.y -= 50;
                    } else if(tempSymName.indexOf("x3") > -1) {
                        this._spineAttentionSymbols[reel][i].scale.set(1, 1);
                        this._spineAttentionSymbols[reel][i].position.x -= 120;
                        this._spineAttentionSymbols[reel][i].position.y -= 100;
                    } else {
                        this._spineAttentionSymbols[reel][i].scale.set(120 / 360, 120 / 360);
                    }
                    if(this._soundPlayedOnReel[reel] == false) {
                        this._soundPlayedOnReel[reel] = true;
                        (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SYMBOL_HIGHLIGHT)});
                    }
                    this._spineAttentionSymbols[reel][i].skeleton.setSlotsToSetupPose();
                    this._spineAttentionSymbols[reel][i].updateTransform();
                    this._spineAttentionSymbols[reel][i].visible = true;
                    new SpineTween(this._spineAttentionSymbols[reel][i], 0, "animation", 0);
                }
            }
        }
        hightlightTL.add(() => {
            for(let i:number = 0; i < positions.length; i++) {
                if(positions[i] == true) {
                    this._spineAttentionSymbols[reel][i].visible = false;
                }
            }
        }, "+=1");
    }

    public getAvalancheSymbolAttentionTL(reel:number, winPositions:boolean[], allWinPositions:boolean[]):TimelineLite {
        const mainSymbolInitialWin:TimelineLite = new TimelineLite();
        const subTLs:TimelineLite[] = [];
        this._winPositions[reel] = winPositions;

        let tempSymName:string;
        let animationName:string = "1x1_win";
        for(let i:number = 0; i < winPositions.length; i++) {
            let subTL:TimelineLite = new TimelineLite();
            if(winPositions[i] == true) {
                tempSymName = Reels.getSymbol(reel, i)!.symName;
                if(tempSymName.indexOf("hidden") == -1 || tempSymName == "W_hidden") {
                    animationName = "1x1_win";
                    if(tempSymName.indexOf("x2") > -1 || tempSymName.indexOf("x3") > -1) {
                        mainSymbolInitialWin.add(MonkeysGoldGameModuleConfig.monkeysGoldBigSymbolLandView.wildsDropTL, 0);
                        mainSymbolInitialWin.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SYMBOLS_HIGHLIGHT)}));
                    }
                    if(tempSymName.indexOf("x2") > -1) {
                        animationName = "2x2_win";
                        this._spineSymbols[reel][i].position.x -= 60;
                        this._spineSymbols[reel][i].position.y -= 50;
                    } else if(tempSymName.indexOf("x3") > -1) {
                        animationName = "3x3_win";
                        this._spineSymbols[reel][i].position.x -= 120;
                        this._spineSymbols[reel][i].position.y -= 100;
                    }
                    subTL.add(() => MonkeysGoldGameModuleConfig.monkeysGoldBackgroundSoundController.playSymbolHighlightSound());
                    subTL.add(() => this._spineSymbols[reel][i].skeleton.setSlotsToSetupPose());
                    subTL.add(() => this._spineSymbols[reel][i].updateTransform());
                    subTL.add(() => this._spineSymbols[reel][i].visible = true);
                    subTL.add(new SpineTween(this._spineSymbols[reel][i], 0, animationName, 0));
                    subTL.add(() => this._spineSymbols[reel][i].visible = false);
                    subTL.add(() => this._spineSymbols[reel][i].position.x = Helper.getSymbolPositions(reel, i)[0]);
                    subTL.add(() => this._spineSymbols[reel][i].position.y = Helper.getSymbolPositions(reel, i)[1]);
                }
            }
            subTLs.push(subTL);
        }
        for(let i:number = 0; i < allWinPositions.length; i++) {
            let tempSym:StateReelSymbol;
            let subTL:TimelineLite = new TimelineLite();
            if(allWinPositions[i] == false) {
                let noWinSymName:string = Reels.getSymbol(reel, i)!.symName;
                if(noWinSymName.indexOf("hidden") == -1) {
                    if(noWinSymName.indexOf("x2") > -1 || noWinSymName.indexOf("x3") > -1) {
                        subTL.add(MonkeysGoldGameModuleConfig.monkeysGoldBigSymbolLandView.wildsDropTL);
                    }
                }
                subTL.add(() => tempSym = <StateReelSymbol>Reels.allSymbols(reel)[i]);
                subTL.add(new TweenLite((<StateReelSymbol>Reels.getSymbol(reel, i)), 0.4, {
                    alpha : 0,
                    ease : Linear.easeNone
                }));
                subTL.add(() => Reels.getReel(reel)!.view.removeChild(tempSym));
                subTL.add(() => MonkeysGoldGameModuleConfig.monkeysGoldReelPartCreator.deleteSymbol(tempSym));
            }
            subTLs.push(subTL);
        }
        mainSymbolInitialWin.add(subTLs, "+=" + 0.05 * reel);

        return mainSymbolInitialWin;
    }

    public cleanupSpineWinSymbols():void {
        for(let i:number = 0; i < 6; i++) {
            for(let j:number = 0; j < 6; j++) {
                this._spineSymbols[i][j].visible = false;
            }
        }
    }
}